// extracted by mini-css-extract-plugin
module.exports = {"submit":"FormRecuperaPassword_submit__GWMsZ","thankyouMessageText":"FormRecuperaPassword_thankyouMessageText__oKoLK","rotation":"FormRecuperaPassword_rotation__2tvb1"};